export default {
  production: {
    api: "https://community.yuhoukeji.cn",
    // api:"https://test-yuhong.yuhoukeji.cn",
    // api: "https://village.hemeixiangcun.xn--fiqs8s",
    webSocket: "wss://community.yuhoukeji.cn/service-admin/ws/endpoint"
    // webSocket: "ws://121.40.130.95:8700/service-admin/ws/endpoint"
  },
  development: {
    api: "https://community.yuhoukeji.cn",
    // api:"https://test-yuhong.yuhoukeji.cn",
    // api: "http://192.168.20.29:8700",
    // api: "http://192.168.20.87:8700",
    //  webSocket: "ws://121.40.130.95:8700/service-admin/ws/endpoint"
    // webSocket: "ws://test-yuhong.yuhoukeji.cn/service-admin/ws/endpoint"
    webSocket: "wss://community.yuhoukeji.cn/service-admin/ws/endpoint"
    // webSocket: "ws://192.168.20.87:8700/service-admin/ws/endpoint"
  },
};
